import { url } from '@exodus/fetch/url';
const SERVER = new URL('https://api.switchain.com/rest/v3');
const KEY = 'd4bfce0e-e5b6-3a3f-ac2c-b9218427e589';
const HEADERS = { Authorization: `Bearer ${KEY}` };
const getSwitchainOrder = async (id, fetchival) => {
    return fetchival(url `${SERVER}/order/${id}`, { headers: HEADERS }).get();
};
const getProviderOrder = async (providerOrder, fetchival) => {
    const orderInfo = await getSwitchainOrder(providerOrder.id, fetchival);
    return {
        orderId: orderInfo.id,
        depositAddress: orderInfo.depositAddress,
        depositAmount: orderInfo.amountFrom,
        withdrawalAddress: orderInfo.withdrawAddress,
    };
};
const switchainConfig = {
    sw: getProviderOrder,
};
export default switchainConfig;
